'use client';
import React, { useEffect } from 'react';

function Portfolio() {
  function loadBackgroudImages() {
    let backgroudImages = document.querySelectorAll('[data-background]');
    if (backgroudImages.length > 0) {
      backgroudImages.forEach((element) => {
        let image = element.dataset.background;
        element.style.backgroundImage = `url('${image}')`;
      });
    }
  }
  useEffect(() => {
    loadBackgroudImages();
  }, []);
  return (
    <section className="portfolio-tab bord-thin-bottom pb-40" style={{marginBottom: '-200px'}}>
      <div className="container-fluid rest">
        <div className="sec-head pb-50 bord-thin-bottom">
          <div className="container">
            <h6 className="sub-title main-color mb-25">What We Do</h6>
          </div>
          <div className="bord pt-25 bord-thin-top">
            <div className="container">
              <div className="d-flex align-items-center">
                <h2 className="fw-600">
                  Our featured <span className="fw-200">initiatives</span>
                </h2>
                <div className="ml-auto">
                  <a href="/light/page-services2" className="go-more">
                    <span className="text">View all initiatives</span>
                    <span className="icon ti-arrow-top-right"></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-5 rest">
            <div className="glry-img">
              <div id="tab-1" className="bg-img tab-img current" data-background="/light/assets/imgs/spob/initiative-1.jpg"></div>
              <div id="tab-2" className="bg-img tab-img" data-background="/light/assets/imgs/spob/initiative-2.jpg"></div>
              <div id="tab-3" className="bg-img tab-img" data-background="/light/assets/imgs/spob/initiative-3.jpg"></div>
              <div id="tab-4" className="bg-img tab-img" data-background="/light/assets/imgs/spob/initiative-4.jpg"></div>
              <div id="tab-5" className="bg-img tab-img" data-background="/light/assets/imgs/spob/initiative-5.jpg"></div>
            </div>
          </div>
          <div className="col-lg-7 rest content">
            <div className="cluom current" data-tab="tab-1">
              <div className="info">
                <h6 className="sub-title opacity-7">Health</h6>
                <h4>Health Awareness &amp; Community Outreach</h4>
              </div>
              <div className="img">
                <img src="/light/assets/imgs/spob/initiative-1.jpg" alt="Health Awareness" />
              </div>
              <div className="more text-u ls1 fz-12">
                <a href="/light/initiative-health">
                  View Initiative <i className="ml-15 ti-arrow-top-right"></i>
                </a>
              </div>
            </div>
            <div className="cluom" data-tab="tab-2">
              <div className="info">
                <h6 className="sub-title opacity-7">Education</h6>
                <h4>Nigeria School Uniform Equity Initiative</h4>
              </div>
              <div className="img">
                <img src="/light/assets/imgs/spob/initiative-2.jpg" alt="School Uniform Equity" />
              </div>
              <div className="more text-u ls1 fz-12">
                <a href="/light/initiative-nsuei">
                  View Initiative <i className="ml-15 ti-arrow-top-right"></i>
                </a>
              </div>
            </div>
            <div className="cluom" data-tab="tab-3">
              <div className="info">
                <h6 className="sub-title opacity-7">Education</h6>
                <h4>Foundational Learning &amp; Academic Support</h4>
              </div>
              <div className="img">
                <img src="/light/assets/imgs/spob/initiative-3.jpg" alt="Foundational Learning" />
              </div>
              <div className="more text-u ls1 fz-12">
                <a href="/light/initiative-flasi">
                  View Initiative <i className="ml-15 ti-arrow-top-right"></i>
                </a>
              </div>
            </div>
            <div className="cluom" data-tab="tab-4">
              <div className="info">
                <h6 className="sub-title opacity-7">Culture</h6>
                <h4>Yoruba Heritage &amp; Language Cultural Literacy</h4>
              </div>
              <div className="img">
                <img src="/light/assets/imgs/spob/initiative-4.jpg" alt="Yoruba Heritage" />
              </div>
              <div className="more text-u ls1 fz-12">
                <a href="/light/initiative-yoruba">
                  View Initiative <i className="ml-15 ti-arrow-top-right"></i>
                </a>
              </div>
            </div>
            <div className="cluom" data-tab="tab-5">
              <div className="info">
                <h6 className="sub-title opacity-7">Environment</h6>
                <h4>Eco-Awareness &amp; Environmental Sustainability</h4>
              </div>
              <div className="img">
                <img src="/light/assets/imgs/spob/initiative-5.jpg" alt="Eco-Awareness" />
              </div>
              <div className="more text-u ls1 fz-12">
                <a href="/light/initiative-eco">
                  View Initiative <i className="ml-15 ti-arrow-top-right"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
